<template>
  <div class="container-fluid">
    <!-- <ModalEditionLieuConsommation ref="ajouterLieuConsommation" action="ajouter" :structures="structures" :barquettes="listeBarquettes" @enregistrer-lieu="enregistrerLieu($event)" @annuler-edition="fermerModalCreation()" />
    <ModalEditionLieuConsommation ref="modifierLieuConsommation" action="modifier" :lieuConsommationId="idLieuSelectionne" :structures="structures" :barquettes="listeBarquettes" @enregistrer-lieu="enregistrerLieu($event)" @annuler-edition="fermerModalEdition()" /> -->
    <ModalEditionLieuConsommation ref="ajouterLieuConsommation" @enregistrer-lieu="enregistrerLieu($event)" @annuler-edition="fermerModalCreation()" />
    <ModalEditionLieuConsommation ref="modifierLieuConsommation" :lieuConsommationId="idLieuSelectionne" @enregistrer-lieu="enregistrerLieu($event)" @annuler-edition="fermerModalEdition()" />

    <BarreFiltres :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />
    <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />

    <div class="card table-scroll height-responsive-100">
      <table class="table table-bordered table-sm text-center table-header">
        <colgroup>
          <col width="300">
          <col>
          <col width="170">
          <col width="400">
          <col width="80">
          <col width="80">
        </colgroup>
        <thead>
          <th>Nom</th>
          <th>Adresse</th>
          <th>Jours de consommation</th>
          <th>Catégories</th>
          <th>Effectifs</th>
          <th>Plat témoin</th>
        </thead>
      </table>
      <div class="table-body">
        <table class="table table-bordered table-sm text-center">
          <colgroup>
            <col width="300">
            <col>
            <col width="170">
            <col width="400">
            <col width="80">
            <col width="75">
          </colgroup>
          <tbody>
            <template v-for="(lieu, iLieu) in lieuxFiltres">
              <!--Ligne du lieu de consommation-->
              <tr :class="[{'ligne-selectionnee':lieu.id === idLieuSelectionne}, {'ligne-desactivee':!lieu.actif}]" :key="iLieu" @click="selectionnerLieu(lieu)">
                <td :rowspan="incrementRowSpan(lieu)" class="aligner-gauche">{{ lieu.libelle }}</td>
                <td :rowspan="incrementRowSpan(lieu)" class="aligner-gauche">{{ lieu.adresseComplete }}</td>
                <td :rowspan="incrementRowSpan(lieu)"><p v-if="lieu.joursConsommation" style="margin-top:10px;">{{lieu.joursConsommation}}</p></td>
                <td>{{ lieu.syntheseEffectifs && lieu.syntheseEffectifs.length }} dont {{ lieu.syntheseEffectifs && lieu.syntheseEffectifs.filter(s => s.effectifs === 0).length }} sans effectif</td>
                <td>{{ lieu.syntheseEffectifs && lieu.syntheseEffectifs.map(e => e.effectifs).reduce((a, c) => a + c, 0) || 0 }}</td>
                <td>
                  <i v-if="lieu.syntheseEffectifs && lieu.syntheseEffectifs.some(e => e.aPlatTemoin)" title="Plat témoin" class="fas fa-check" style="font-weight:bold"></i>
                </td>
              </tr>

              <!-- lignes des structures / effectifs-->
              <template v-for="(effectif, iEffectif) in (lieu.syntheseEffectifs && lieu.syntheseEffectifs.filter(x => x.effectifs !== 0))">
                <tr :key="'lieu-'+iLieu+'-effectif-'+iEffectif" v-if="detaillerEffectifs" :class="[{'ligne-selectionnee':lieu.id === idLieuSelectionne}, {'ligne-desactivee':!lieu.actif}]" @click="selectionnerLieu(lieu)">
                  <td class="aligner-gauche">
                    {{effectif.nomTypeConvive}} {{effectif.nomStructureMenu}} {{effectif.nomTypeService}} {{effectif.nomTypeRegime}} {{effectif.nomTypeTexture}}
                  </td>
                  <td>
                    {{effectif.effectifs}}
                  </td>
                  <td>
                    <i v-if="effectif.aPlatTemoin" title="Plat témoin" class="fas fa-check"></i>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- <b-modal id="modalTriLieux" size="xl" hide-footer header-bg-variant="gradient-bleu" header-text-variant="light" no-close-on-backdrop>
      <template slot="modal-title">
        Ordre des lieux de consommation (modification par glisser / déposer)
      </template>
      <template slot="default">
        <div class="row" :key="keyTri">
          <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12" v-for="lieu in lieuxTri" :key="lieu.LieuId" @dragstart="dragStart($event, lieu)" @drop="drop($event, lieu)" @dragover="dragOver($event)">
            <div class="card">
              <div :class="[{'card-header bg-gradient-bleu text-white':lieu.Actif}, {'card-header bg-secondary text-white':!lieu.Actif}]" style="border-radius:0;" draggable="true">
                ({{ lieu.Ordre}}) {{ lieu.libelle }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-actions right mt-2">
          <b-button type="submit" variant="success" alt="Enregistrer" style="float:right;" @click="enregistrerTri">Enregistrer</b-button>
          <b-button type="submit" variant="danger" alt="Annuler" style="float:right;margin-right:10px;" @click="annulerTri">Annuler</b-button>
        </div>
      </template>
    </b-modal> -->

    <!-- <b-modal id="modalEditionJours" size="lg" hide-footer header-bg-variant="gradient-bleu" header-text-variant="light" no-close-on-backdrop>
      <template slot="modal-title">
        Modifier les jours d'ouverture des lieux de portage
      </template>
      <template slot="default">
        <table class="table table-bordered table-sm text-center table-header">
          <colgroup>
            <col width="*">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
          </colgroup>
          <thead>
            <th>Lieu de portage</th>
            <th>Lundi</th>
            <th>Mardi</th>
            <th>Mercredi</th>
            <th>Jeudi</th>
            <th>Vendredi</th>
            <th>Samedi</th>
            <th>Dimanche</th>
            <th>Actif</th>
          </thead>
        </table>
        <div class="table-body">
          <table class="table table-bordered table-sm text-center">
            <colgroup>
              <col width="*">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
            </colgroup>
            <tbody>
              <tr v-for="lieu in lieuxJours" :key="lieu.id">
                <td>{{lieu.libelle}}</td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(1)" @change="jourChanged(lieu, 1, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(2)" @change="jourChanged(lieu, 2, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(3)" @change="jourChanged(lieu, 3, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(4)" @change="jourChanged(lieu, 4, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(5)" @change="jourChanged(lieu, 5, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(6)" @change="jourChanged(lieu, 6, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(0)" @change="jourChanged(lieu, 0, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.actif" @change="jourChanged(lieu, -1, $event.currentTarget.checked)" /></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-actions right mt-2">
          <b-button type="submit" variant="success" alt="Enregistrer" style="float:right;" @click="enregistrerJours">Enregistrer</b-button>
          <b-button type="submit" variant="danger" alt="Annuler" style="float:right;margin-right:10px;" @click="fermerJours">Annuler</b-button>
        </div>
      </template>
    </b-modal> -->
  </div>
</template>

<script>
import BarreFiltres from '@/components/Divers/BarreFiltres'
import BarreActions from '@/components/Divers/BarreActions'
import ModalEditionLieuConsommation from '@/components/Menus/ModalEditionLieuConsommation'
import { connecteData } from "@/mixins/connecteData"
import { effectifsLieuConsommation } from '@/mixins/menus'
import { getLieuxConsommation, changerStatutActifLieuConsommation, supprimerLieuConsommation } from "@/api/gpao/menus"
//import { obtenirBarquettes } from '@/api/gpao/production'
//import { setLieuxPortage, sortLieuxPortage, groupeModifLieuxPortage } from '@/api/gpao/user'
import { showAlerts } from "@/mixins/alerts"
//import vm from "@/helpers/vm-toolkit-vue"
import _ from "lodash"

export default {
  components: { BarreFiltres, BarreActions, ModalEditionLieuConsommation },
  mixins: [ connecteData, showAlerts, effectifsLieuConsommation ],
  name: "PageLieuxConsommation",
  data() {
    return {
      enAjoutPortage: false,
      afficherInactifs: true,
      detaillerEffectifs: false,
      idLieuSelectionne: null,
      //listeBarquettes: [],
      lieux: [],
      //structures: [],
      nouveauLieu: {},
      //enEditionLieu: {},
      filtreLieux: "",
      lieuxTri: [],
      lieuxJours: [],
      keyTri: 1,
      filtres: {
        recherche: {
          label: "Recherche lieu de consommation",
          champ: "input",
          type: "text",
          effacer: "Effacer la recherche",
          selection: "",
          class: "search",
          filtrer(contexte, valeur) {
            let filtre = contexte.filtres.recherche
            if (valeur) {
              filtre.selection = valeur
            }
            contexte.filtreLieux = filtre.selection || ""
          }
        },
        afficherInactifs: {
          label: "Afficher les inactifs",
          champ: "checkbox",
          selection: true,
          initialiser(contexte) {
            contexte.filtres.afficherInactifs.selection = contexte.$store.state.stock.filtresEnMemoire.afficherInactifs
            contexte.filtres.afficherInactifs.filtrer(contexte)
          },
          async filtrer(contexte) {
            contexte.afficherInactifs = contexte.filtres.afficherInactifs.selection
            contexte.$store.commit('stock/setFiltresEnMemoire', {key: 'afficherInactifs', data: contexte.filtres.afficherInactifs.selection})
          }
        },
        detaillerEffectifs: {
          label: "Détailler les catégories",
          champ: "checkbox",
          selection: false,
          initialiser(contexte) {
            contexte.filtres.detaillerEffectifs.selection = contexte.$store.state.stock.filtresEnMemoire.detailEffectifs
            contexte.filtres.detaillerEffectifs.filtrer(contexte)
          },
          async filtrer(contexte) {
            contexte.detaillerEffectifs = contexte.filtres.detaillerEffectifs.selection
            contexte.$store.commit('stock/setFiltresEnMemoire', {key: 'detailEffectifs', data: contexte.filtres.detaillerEffectifs.selection})
          }
        },
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.filtres.barreGauche = [ contexte.filtres.recherche, contexte.filtres.afficherInactifs, contexte.filtres.detaillerEffectifs ]
          contexte.filtres.barreGauche.forEach(f => {
            if (f.initialiser) {
              f.initialiser(contexte)
            }
          })
        }
      },
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        ajouter: {
          label: "Ajouter un lieu",
          async methode(contexte) {
            contexte.ajouterLieu()
          }
        },
        // trierLieux: {
        //   label: "Trier les lieux de portage",
        //   champ: "btn",
        //   methode(contexte) {
        //     contexte.trierLieux()
        //   }
        // },
        // modifierJours: {
        //   label: "Modifier les jours d'ouverture",
        //   champ: "btn",
        //   methode(contexte) {
        //     contexte.modifierJours()
        //   }
        // },
        ouvrir: {
          label: "Ouvrir",
          disabled: true,
          methode(contexte) {
            let l = contexte.lieuSelectionne
            if (l) {
              contexte.modifierLieu(l.id)
            }
          }
        },
        changerStatutActif: {
          label: "Désactiver",
          disabled: true,
          changerLabel(contexte) {
            let btn = contexte.actions.changerStatutActif
            let lieu = contexte.lieuSelectionne
            if (lieu?.actif) {
              btn.label = "Désactiver"
            } else {
              btn.label = "Activer"
            }
          },
          methode(contexte) {
            contexte.activerDesactiverLieuSelectionne()
          }
        },
        supprimer: {
          label: "Supprimer",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            contexte.supprimerLieuSelectionne()
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ contexte.actions.ajouter/*, contexte.actions.trierLieux, contexte.actions.modifierJours*/ ]
          contexte.actions.barreDroite = [ contexte.actions.ouvrir, contexte.actions.changerStatutActif, contexte.actions.supprimer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.ouvrir, actions.changerStatutActif, actions.supprimer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        },
        changerLabels(contexte) {
          let actionsATraiter = [ contexte.actions.changerStatutActif ]
          actionsATraiter.forEach(a => a.changerLabel(contexte))
        }
      }
    }
  },
  mounted() {
    this.chargerLieux()
    this.filtres.initialiser(this)
    this.actions.initialiser(this)
  },
  computed: {
    lieuxFiltres() {
      var lieux
      if (!this.filtreLieux) {
        lieux = this.lieux
      } else {
        lieux = this.lieux.filter(lieu => lieu.libelle.toLocaleLowerCase().indexOf(this.filtreLieux.toLocaleLowerCase()) > -1)
      }
      if (!this.afficherInactifs) {
        lieux = lieux.filter(l => l.actif)
      }
      return lieux.sort((a, b) => a.libelle - b.libelle)
    },
    lieuSelectionne() {
      return this.lieuxFiltres?.find(c => c.id === this.idLieuSelectionne)
    },
    lieuSelectionneActif() {
      return this.lieuSelectionne?.actif ?? true
    }
  },
  watch: {
    etabCourantId() {
      this.chargerLieux()
    },
    lieuSelectionne() {
      this.actions.disable(this.actions, !this.lieuSelectionne)
    },
    lieuSelectionneActif() {
      this.actions.changerLabels(this)
    }
  },
  methods: {
    appliquerFiltre(filtrer) {
      filtrer(this)
    },
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },
    incrementRowSpan(lieu) {
      return this.detaillerEffectifs ? lieu.syntheseEffectifs.filter(e => e.effectifs !== 0)?.length + 1 : 1
    },
    async chargerLieux() {
      var response = await getLieuxConsommation(this.etabCourantId)
      //this.lieux = response.data.lieuxConsommation
      this.lieux = response.data
      this.lieux.forEach(l => {
        l.syntheseEffectifs = this.detailVersRecap(l.effectifsParDefaut)
      })
      //this.structures = response.data.structures
      this.$store.commit('user/setALieuPortage', {eId: this.etabCourantId, aLieuPortage: this.lieux && this.lieux.filter(l => l.actif).length > 0})

      // //Chargement des barquettes possibles
      // let ret = await obtenirBarquettes(this.etabCourantId)
      // this.listeBarquettes = ret.data || []
    },
    selectionnerLieu(lieu) {
      if (lieu.id === this.idLieuSelectionne) {
        this.modifierLieu(lieu.id)
        return
      }
      this.idLieuSelectionne = lieu.id
      this.actions.disable(this.actions, !this.lieuSelectionne)
      this.actions.changerLabels(this)
    },
    ajouterLieu() {
      //this.$refs.ajouterLieuConsommation.show()
      this.$router.push({
        name: "LieuConsommation",
        params: { etablissementId: this.etabCourantId }
      })
    },
    modifierLieu() {
      //this.enEditionLieu = this.lieux.find(x => x.id === lieuId)
      //this.$refs.modifierLieuConsommation.show()
      if (this.idLieuSelectionne) {
        this.$router.push({
          name: "LieuConsommation",
          params: {
            etablissementId: this.etabCourantId,
            lieuConsommationId: this.idLieuSelectionne
          }
        })
      }
    },
    async activerDesactiverLieuSelectionne() {
      if (this.idLieuSelectionne) {
        let response = await changerStatutActifLieuConsommation(this.idLieuSelectionne)
        this.lieuSelectionne.actif = response.data
        this.$store.commit('user/setALieuPortage', {eId: this.etabCourantId, aLieuPortage: this.lieux && this.lieux.filter(l => l.actif).length > 0})
      }
    },
    // trierLieux() {
    //   this.lieuxTri = this.lieux.map(lieu => {
    //     return {
    //       LieuId: lieu.id,
    //       libelle: lieu.libelle,
    //       Ordre: lieu.ordreLivraison,
    //       Actif: lieu.actif
    //     }
    //   })
    //   this.lieuxTri.sort((a, b) => a.Ordre - b.Ordre)
    //   this.$bvModal.show('modalTriLieux')
    // },
    // dragStart(e, lieu) {
    //   e.dataTransfer.dropEffect = "move"
    //   e.dataTransfer.setData("text/plain", lieu.LieuId)
    // },
    // dragOver(e) {
    //   e.preventDefault()
    // },
    // drop(e, destination) {
    //   e.preventDefault()
    //   var source = this.lieuxTri.find(l => l.LieuId === Number(e.dataTransfer.getData("text/plain")))
    //   var ordreDest = destination.Ordre
    //   if (source.Ordre < destination.Ordre) {
    //     this.lieuxTri.forEach(lieu => {
    //       if (lieu.Ordre > source.Ordre && lieu.Ordre <= destination.Ordre && lieu.LieuId !== source.LieuId) {
    //         lieu.Ordre -= 1
    //       }
    //     })
    //   } else if (source.Ordre > destination.Ordre) {
    //     this.lieuxTri.forEach(lieu => {
    //       if (lieu.Ordre < source.Ordre && lieu.Ordre >= destination.Ordre && lieu.LieuId !== source.LieuId) {
    //         lieu.Ordre += 1
    //       }
    //     })
    //   }
    //   source.Ordre = ordreDest
    //   this.lieuxTri = this.lieuxTri.sort((a, b) => a.Ordre - b.Ordre)
    // },
    // annulerTri() {
    //   this.$bvModal.hide('modalTriLieux')
    // },
    // enregistrerTri() {
    //   this.annulerTri()
    //   this.lieuxTri.forEach(lieu => {
    //     this.lieux.find(l => l.id === lieu.LieuId).ordreLivraison = lieu.Ordre
    //   })
    //   return sortLieuxPortage(this.lieuxTri)
    //     .then(() => {
    //       this.alerteSucces('Tri enregistré !')
    //       return
    //     })
    // },
    // fermerModalCreation() {
    //   this.$refs.ajouterLieuConsommation.hide()
    // },
    // fermerModalEdition() {
    //   this.$refs.modifierLieuConsommation.hide()
    // },
    async supprimerLieuSelectionne() {
      if (this.idLieuSelectionne) {
        let reponse = await this.alerteConfirmationSuppression('Supprimer le lieu de portage', "Souhaitez-vous supprimer définitivement le lieu de portage \"" + this.lieuSelectionne.libelle + "\" ?")
        if (reponse) {
          await supprimerLieuConsommation(this.idLieuSelectionne)
          this.chargerLieux()
          this.alerteSucces('Lieu supprimé !')
        }
      }
    },
    // joursOuverture(lieu) {
    //   var txt = ""
    //   lieu.joursOuverture.forEach(jour => {
    //     if (jour === 0) {
    //       txt += (txt ? ", " : "") + "Di"
    //     } else if (jour === 1) {
    //       txt += (txt ? ", " : "") + "Lu"
    //     } else if (jour === 2) {
    //       txt += (txt ? ", " : "") + "Ma"
    //     } else if (jour === 3) {
    //       txt += (txt ? ", " : "") + "Me"
    //     } else if (jour === 4) {
    //       txt += (txt ? ", " : "") + "Je"
    //     } else if (jour === 5) {
    //       txt += (txt ? ", " : "") + "Ve"
    //     } else if (jour === 6) {
    //       txt += (txt ? ", " : "") + "Sa"
    //     }
    //   })
    //   if (txt) {
    //     //txt = "Ouvert le : " + txt + "."
    //   }
    //   return txt
    // },
    // modifierJours() {
    //   this.lieuxJours = this.lieux.map(lieu => {
    //     return {
    //       lieuId: lieu.id,
    //       actif: lieu.actif,
    //       libelle: lieu.libelle,
    //       joursOuverture: vm.clone(lieu.joursOuverture),
    //       mod: false
    //     }
    //   })
    //   this.$bvModal.show("modalEditionJours")
    // },
    // jourChanged(lieu, jour, ouvert) {
    //   if (jour === -1) {
    //     lieu.actif = ouvert
    //     lieu.mod = true
    //   } else if (ouvert && !lieu.joursOuverture.includes(jour)) {
    //     lieu.joursOuverture.push(jour)
    //     lieu.mod = true
    //   } else if (!ouvert && lieu.joursOuverture.includes(jour)) {
    //     lieu.joursOuverture.splice(lieu.joursOuverture.indexOf(jour), 1)
    //     lieu.mod = true
    //   }
    //   lieu.joursOuverture = lieu.joursOuverture.sort((a, b) => (a || 7) - (b || 7))
    // },
    // enregistrerJours() {
    //   this.fermerJours()
    //   this.lieuxJours.forEach(lj => {
    //     var lieu = this.lieux.find(l => l.id === lj.lieuId)
    //     lieu.joursOuverture = lj.joursOuverture
    //     lieu.actif = lj.actif
    //   })
    //   var mods = this.lieuxJours.filter(j => j.mod)
    //   if (!mods.length) {
    //     return
    //   }
    //   return groupeModifLieuxPortage(mods)
    //     .then(() => {
    //       this.alerteSucces("Jours d'ouverture enregistrés !")
    //       return
    //     })
    // },
    // fermerJours() {
    //   this.$bvModal.hide("modalEditionJours")
    // }
  }
}
</script>
